import { Platform } from './rn';

/**
 * Yerel iOS cam malzemesine tek erişim noktası (7.14 · D-546 · D-548).
 *
 * `expo-glass-effect` native; bu ikiliyi taşımayan derleme onu yükleyemez, o
 * yüzden dosya yüklenirken değil ilk sorulduğunda isteniyor. Aynı desen
 * `calls/media`, `media/captureLocation` ve `voice/recorder` içinde de var.
 *
 * Neden ayrı dosya: malzemeyi kullanan ikinci yüzey (alt çubuk) çıkınca,
 * `require` ve uygunluk kontrolü iki yere kopyalanacaktı. D-506'da ölçülen
 * kusur tam olarak buydu — cam stilleri iki dosyada birebir aynı duruyordu ve
 * aynı kalmaları şansa bağlıydı. Erişim tek yerde.
 */
type GlassModule = {
  GlassView?: React.ComponentType<any>;
  GlassContainer?: React.ComponentType<any>;
  isLiquidGlassAvailable?: () => boolean;
} | null;

let onbellek: { yuklendi: boolean; modul: GlassModule } = { yuklendi: false, modul: null };

function modul(): GlassModule {
  if (!onbellek.yuklendi) {
    try {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      onbellek = { yuklendi: true, modul: require('expo-glass-effect') as GlassModule };
    } catch {
      onbellek = { yuklendi: true, modul: null };
    }
  }
  return onbellek.modul;
}

/**
 * Yerel malzeme bu cihazda var mı.
 *
 * Üç koşul birden ve bu sırayla: platform iOS (Android native modülü hiç
 * sormaz), paket ikilide mevcut, ve sistem Liquid Glass kullanıyor. Üçüncüsü
 * çalışma zamanı sorusudur — aynı ikili iOS 26'da true, daha eskisinde false
 * döner.
 */
export function nativeGlassAvailable(): boolean {
  if (Platform.OS !== 'ios') return false;
  try {
    return modul()?.isLiquidGlassAvailable?.() === true;
  } catch {
    return false;
  }
}

/** Malzeme yoksa undefined; çağıran kendi yedek yüzeyini çizer. */
export function getGlassView(): React.ComponentType<any> | undefined {
  return nativeGlassAvailable() ? modul()?.GlassView : undefined;
}
